import styled, { css } from 'styled-components';
import { media } from 'src/ui/common/mixins/media';
import { Typography } from 'src/ui/common/atoms/typography';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { NftCardMedia } from '../nft-card-media';

export const StyledWrapper = styled.div<{ variant: 'dark' | 'light' }>`
  position: relative;
  min-width: 172px;
  border-radius: 5px;
  background-color: ${({ theme, variant }) => variant === 'dark' ? theme.colors.gs500 : theme.colors.white};

  ${media.md`
    min-width: 220px;
  `}
`;

export const StyledInfo = styled.div`
  padding: 20px 15px 15px;
  
  ${media.sm`
    padding: 20px;
  `}
`;

export const StyledCreatorName = styled(Typography)`
  color: ${({ theme }) => theme.colors.gs200};

  ${media.sm`
    font-size: 14px;
  `};
`;

export const StyledName = styled(Typography) <{ withCopies: boolean, cardVariant: 'dark' | 'light' }>`
  color: ${({ cardVariant, theme }) => cardVariant === 'dark' ? theme.colors.white : theme.colors.warmBlack};
  margin-top: 6px;
  position: relative;
  
  ${({ withCopies }) => withCopies && 'padding-right: 50px;'}
  
  & > i {
    color: ${({ theme }) => theme.colors.gs200};
    margin-left: 8px;
    position: absolute;
    right: 0;
    top: 0;
  }

  ${media.sm`
    font-size: 16px;
  `};
`;

export const StyledNftCardMedia = styled(NftCardMedia)`
  border-radius: 5px;
  overflow: hidden;
`;

export const StyledPrices = styled.div<{ notOnSale: boolean, notMinted: boolean, variant: 'dark' | 'light' }>`
  ${({ notMinted, notOnSale, theme, variant }) => {
    if (notMinted) {
      return `color: ${theme.colors.pink500};`;
    }
    if (notOnSale) {
      return `color: ${theme.colors.gs200};`;
    }
    if (variant==='light') {
      return `color: ${theme.colors.warmBlack};`;
    }
    return `color: ${theme.colors.white};`;
  }};

  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 45px;

  svg {
    width: 16px !important;;
    height: 16px !important;
    flex: 0 0 16px;
    margin-right: 10px;
    
    ${({ notMinted, theme }) => notMinted && css`
      color: ${theme.colors.pink500};
    `}
  }
  
  ${media.sm`
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    height: 19px;
    white-space: nowrap;
  
    & > span {
      font-weight: 500;
    }
  `};
  
  ${media.md`
    svg {
      width: 20px !important;;
      height: 20px !important;
      flex: 0 0 20px;
    }
  `}
`;

export const NotOnSaleIcon = styled(SvgIcon)`
  margin-right: 10px;
`;

export const StyledFiatPrice = styled(FlexBox)`
  margin-top: 10px;
  font-weight: 500;
  
  ${media.sm`
    margin-top: 0;
    margin-left: 15px;
  `}
`;

export const StyledAuction = styled(FlexBox)`
  font-size: 13px;
  
  ${media.md`
    font-size: 14px;
  `}
`;

export const StyledSubtitle = styled.div`
  height: 22px;
  
  & a {
    display: inline-block;
  }
`;

export const StyledTypeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1;
  background-color: rgba(13, 12, 12, 0.5);
  height: 32px;
  width: 32px;
  border-radius: 50%;
 

  ${media.sm(css`
    height: 34px;
    width: 34px;
  `)}
`;